












import { defineComponent } from "@vue/composition-api";
import draggable from "vuedraggable";

export default defineComponent({
  name: "SmallCallModalView",
  components: { draggable },
  props: {
    hasVideo: {
      type: Boolean,
      required: true,
    },
  },
});
